export default __webpack_public_path__ + "static/media/Check.32b1185e.svg";